import { render, staticRenderFns } from "./ButtonColors.vue?vue&type=template&id=909f1834&scoped=true"
import script from "./ButtonColors.vue?vue&type=script&lang=js"
export * from "./ButtonColors.vue?vue&type=script&lang=js"
import style0 from "./ButtonColors.vue?vue&type=style&index=0&id=909f1834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909f1834",
  null
  
)

export default component.exports